// 📦 Bouton d'impression pour un contact donné
// 📦 Import des dépendances
import React from "react";
import { Button, Tooltip, useMediaQuery, Box, Typography} from "@mui/material";
import { printContactList } from "../utils/printUtils.js"; // adapte le chemin si nécessaire
import { useLanguage } from "../context/LanguageContext.js";
import { logDev } from "../utils/logger.js";

const PrintButton = ({ contact, rows,nomGroupe, emojiGroupe, couleurGroupe }) => {
  const { t } = useLanguage();
  const isMobile = useMediaQuery("(max-width:600px)");

  // 🔹 Action : lancer l'impression
  const handlePrint = () => {
    if (!contact || !contact._id) {
      logDev("❌ Contact invalide pour impression", { contact });
      alert(t("NoContactSelected") || "Aucun contact sélectionné");
      return;
    }
    
    // 🔹 Appelle l'utilitaire qui génère la fenêtre d'impression
    printContactList(contact, rows, {
      nom: nomGroupe,
      emoji: emojiGroupe,
      couleur: couleurGroupe
    });
  };

  // 👉 Version mobile : icône + prénom en dessous
  if (isMobile) {
    return (
      <Tooltip title={contact ? `${t("PrintFor")} ${contact.nom}` : t("NoContactSelected")}>
        <Box 
          onClick={handlePrint}
          sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center", 
            cursor: "pointer" 
          }}
        >
          <span style={{ fontSize: "1.5rem" }}>🖨️</span>
          <Typography variant="caption" sx={{ fontSize: "0.7rem", marginTop: "2px" }}>
            {contact?.nom}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  // 👉 Version desktop : bouton classique
  return (
    <Tooltip title={contact ? `${t("PrintFor")} ${contact.nom}` : t("NoContactSelected")}>
    <span>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<span>🖨️</span>}
        onClick={handlePrint}
        className="print-button"
        sx={{
          fontSize: { xs: "0.9rem", sm: "0.85rem" },   // 👈 plus grand sur mobile
          padding: { xs: "8px 14px", sm: "6px 12px" }, // 👈 plus de marge sur mobile
          minWidth: { xs: 80, sm: 100 },               // 👈 largeur minimale augmentée
          marginRight: 1
        }}
      >
       {`${t("PrintFor")} ${contact.nom}`}  
      </Button>
    </span>
    </Tooltip >
  );
};

export default PrintButton;
